export default {
  colors: {
    black: '#141414',
    green: '#00d6b2',
    red: '#FF6C6C',
    lightGrey: '#ebebeb',
  },
  footerHeight: 50,
  footerMargin: 20,
  fontBody: "'Playfair Display', serif",
  fontBold: "'Montserrat', sans-serif",
};



// WEBPACK FOOTER //
// ./src/styles/theme.js